export enum MovementAmplitudeTypes {
    Measurement = 'measurement',
    Comparison = 'comparison',
}
